<template>
  <div
    class="vm-page"
    :class="{'wechat_mini': GL.ENV.is_wechat_mini, 'afd-client':GL.ENV.is_afd_client}"
  >
    <slot name="nav-header">
      <nav-header-pc
        v-if="browser_size != 'small' && !mixin_is_aricle_edit && !(GL.ENV.is_iPad && GL.ENV.is_afd_client)"
      ></nav-header-pc>
      <nav-stack-mobile
        v-if="browser_size == 'small' && !GL.ENV.is_wechat_mini && mixin_is_show_nav_stack_mobile"
      ></nav-stack-mobile>
      <nav-menu-client
        v-if="mixin_is_show_nav_menu_client"
      ></nav-menu-client>
    </slot>

    <section class="page-box">
      <div class="page-tit">
        <slot name="page-tit"></slot>
      </div>
      <section class="page-content">
        <slot></slot>
      </section>
    </section>

    <section class="page-content-w100">
      <slot name="page-content-w100"></slot>
    </section>

    <slot name="footer">
      <footer-custom
        ref="footer"
        v-if="!is_no_footer && browser_size != 'small'"
        :class="{relative: is_overflow, on: is_show}"
      ></footer-custom>
    </slot>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "page",
  props: {
    is_no_footer: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      go: null,
      is_overflow: false,
      is_show: false
    };
  },
  computed: {
    ...mapState("app", ["browser_size"])
  },
  mounted() {
    //        this.$bus.$on('WINDOW_RESIZE',(e) => {
    //            this.footer_location()
    //        })

    //        this.$bus.$on('LOADING_START', () => {
    //            console.log('LOADING_START')
    //            this.is_show = false
    //        })
    //
    //        this.$bus.$on('LOADING_FINISH', () => {
    //            console.log('LOADING_FINISH')
    //            this.is_show = true;
    //            this.footer_location()
    //        })
    //
    this.$bus.$on("APP_REQUEST_FINISH", () => {
      this.$nextTick(() => {
        this.footer_location();
      });
    });
    //
    this.$bus.$on("IMG_LOADED", () => {
      this.footer_location(true);
    });
    this.$bus.$on("FOOTER_LOCATION", () => {
      this.footer_location(true);
    });
  },
  updated() {
    //     console.log('111')

    // this.footer_location();
  },
  methods: {
    footer_location() {
      this.is_show = false;
      if (this.go) {
        clearTimeout(this.go);
        this.go = null;
      }
      this.go = setTimeout(() => {
        let footer = document.querySelector(".vm-footer-custom");
        let footer_h = 0;
        let footer_pt = 0;
        let footer_pb = 0;
        if (footer) {
          footer_h = footer.clientHeight;
          footer_pt = parseInt(window.getComputedStyle(footer, null)['padding-top'])
          footer_pb = parseInt(window.getComputedStyle(footer, null)['padding-bottom'])
        }
        this.is_overflow =
          this.$el.clientHeight + this.$el.offsetTop + footer_pt + footer_pb + footer_h >
          document.body.clientHeight;
        this.is_show = true;
      }, 100);
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-page{
  max-width: $width-pc;
  margin: 0 auto;

  &.afd-client{
    .page-box {
      margin-top: 0px !important;
    }
  }

  &.wechat_mini {
    .page-box {
      margin-top: 0 !important;
    }
  }

  // min-height calc(100% + 1px)
  .page-box {
    margin-top: px2rem(145);
    box-sizing: border-box;
  }

  .page-tit {
  }

  .page-content {
    width: 640px;
    box-sizing: border-box;
  }

  .vm-footer-custom {
    opacity: 0;
    &.on {
      opacity: 1;
    }
    &.relative {
    //   padding-top: px2rem(120);
    }
  }

  @media (display-mode: fullscreen), (display-mode: standalone){
    padding-bottom: 70px + $afd-safe-area-bottom;
  }

  @media (max-width: $width-mobile) {
    padding-bottom: px2rem(72);

    .page-box {
      margin-top: px2rem(78);
      padding: 0 px2rem(16);
    }

    .page-content {
      width: 100%;
    }
  }

  @media (min-width: $width-mobile + 1) and (max-width: $width-pc) {
    .page-box {
      padding: 0 px2rem(24);
    }

    .vm-footer-custom {
      padding-left: px2rem(24);
      padding-right: px2rem(24);
    }
  }
}
</style>
